import Modal from '../../_bootstrapModalExtensions';
import Classes from '../../_classes';
import * as Url from '../../Utils/UrlUtil';
import NotificationUtil from '../../_notificationUtil';
import * as Takarnet from '../../_takarnet';
import Interfaces from '../../_interfaces';
import * as PleaseWaitModal from '../../Utils/PleaseWaitModal';

export function ShowEditProcessEstateForm(event: JQuery.TriggeredEvent) {
    Modal.showBootstrapModalWithAjaxContent(GetModalSettings(event));

    function GetModalSettings(event: JQuery.TriggeredEvent): Classes.BootstrapModalWithAjaxContentSettings {
        let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();
        const estateId: number = $(event.currentTarget).data('estate-id');
        const processId: number = $(event.currentTarget).data('process-id');
        const extractSubjectEstateId: number = $(event.currentTarget).data('extract-subject-estate-id');
        const canuseTakarnetServices: boolean = $(event.currentTarget).data('can-use-takarnet-services') === 'True';
        const isNewEstate: boolean = $(event.currentTarget).attr('id') === 'add-new-process-estate';

        settings.title = isNewEstate ? 'Új ingatlan felvétele' : 'Ingatlan szerkesztése';
        settings.contentUrl = getContentUrl();
        settings.saveUrl = window.ETDR_RD.appConfig['UrlAction.SaveProcessEstate'];
        settings.enableUnobtrusiveValidation = true;
        settings.closeModalWindowAfterSave = false;
        settings.canSaveUsingEnterKey = false;

        if (canuseTakarnetServices) {
            settings.callback = validateSettlementWithTakarnet;
        } else {
            settings.callback = () => {
                Modal.closeGenericModal();
                refreshProcessEstatesGrid();
            };
        }

        return settings;

        function getContentUrl(): string {
            let template: string = window.ETDR_RD.appConfig['UrlTemplate.EditProcessEstate'];
            let url: string = Url.createUrlFromTemplate(template, {
                processId: processId, estateId: estateId, extractSubjectEstateId: extractSubjectEstateId
            });

            return url;
        }

        function validateSettlementWithTakarnet(response: Interfaces.JsonResponseWithResult): void {
            PleaseWaitModal.Show();
            const estateId: number = response.result as number;
            const successProcessEstateSaveText: string = isNewEstate ? 'Az ingatlan rögzítése sikeres.' : 'Az ingatlan frissítése sikeres';
            const cbOnFailure: () => void = () => {
                refreshProcessEstatesGrid();
                hideModals();
                NotificationUtil.Info(successProcessEstateSaveText);
            };

            Takarnet.GetCountOfMatchedRealtiesFromTakarnet(estateId, cbOnFailure)
                .then(model => {
                    NotificationUtil.Info(successProcessEstateSaveText);

                    notifyUserAboutResult(model);

                    refreshProcessEstatesGrid();
                })
                .finally(() => {
                    hideModals();
                });

            function notifyUserAboutResult(model: Interfaces.JsonResponseWithResult) {
                if (model.success) {
                    if (model.result === 0) {
                        NotificationUtil.Warning(Takarnet.NotFoundEstateMessage);
                    }
                    else if (model.result === 1) {
                        NotificationUtil.Info(Takarnet.ValidEstateMessage);
                    } else if (model.result > 1) {
                        NotificationUtil.Warning(Takarnet.MultipleEstateFoundMessage)
                    }
                }
                else {
                    NotificationUtil.Error(model.message);
                }
            }

            function hideModals() {
                Modal.closeGenericModal();
                PleaseWaitModal.Hide();
            }
        }

        function refreshProcessEstatesGrid() {
            const grid: ASPxClientGridView = window['ProcessEstates'];
            grid.Refresh();
        }
    }
}

$(() => {
    $(document).on('click', '#add-new-process-estate', (event: JQuery.TriggeredEvent) => {
        ShowEditProcessEstateForm(event);
    });

    $(document).on('click', '.edit-subject-estate-new', (event: JQuery.TriggeredEvent) => {
        ShowEditProcessEstateForm(event);
    });
});
